import { useEffect, useState } from 'react'
import { Icon } from 'hello-design-system'
import {
    LevelCompletionScreenContent,
    LevelCompletionVariant,
    NEXT_STEP_LABEL_STORAGE_KEY
} from 'utils/constants'
import {
    pushLevelCompletionCtaClicked,
    pushLevelCompletionPageViewed
} from './levelCompletionAnalytics'
import { FooterSection, ContinueButton } from './styles'

const getContinueCtaLabel = (): string => {
    const nextStepLabel = sessionStorage.getItem(NEXT_STEP_LABEL_STORAGE_KEY)?.trim()
    return nextStepLabel || LevelCompletionScreenContent.continueCta
}

export const ContinueStudyingCta: React.FC<{ onContinue: () => void }> = ({ onContinue }) => {
    const [continueCtaLabel] = useState(getContinueCtaLabel)

    useEffect(() => {
        pushLevelCompletionPageViewed(LevelCompletionVariant.CTA)
    }, [])

    const handleContinue = (): void => {
        pushLevelCompletionCtaClicked()
        onContinue()
    }

    return (
        <FooterSection data-testid='level-completion-cta'>
            <ContinueButton
                id='continue-studying-button'
                data-testid='continue-studying-button'
                color='primary'
                variant='contained'
                size='large'
                endIcon={<Icon iconName='PlayArrowRounded' data-testid='continue-studying-end-icon' />}
                onClick={handleContinue}
            >
                {continueCtaLabel}
            </ContinueButton>
        </FooterSection>
    )
}
